import {createContext} from 'react';

const UserContext = createContext({
    loginString: '',
    userName: '',
    userEmail: '',
    agLocale: {},
    agrlCookie: '',
    userCredentialsCookie: '',
    siteLanguage: 'en',
    siteLanguageDefault: '',
    lacFlag: 'N',
    controlFlag: false,
    accessToken: '',
    timeout: 0,
    mainMenu: [],
    globalConfig: {},
});

export default UserContext;